import React from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import styles from './exam-card.module.css';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../../../../../../constants/common';
import { Tooltip } from 'antd';

const ExamCard = ({ exam, active, onClick }) => {
  const subjects = exam?.subjects || [];
  const visibleSubjects = subjects?.slice(0, 2).join(", ");
  const extraSubjects = subjects?.length > 2 ? subjects?.slice(2) : [];

  return (
    <div
      className={`${styles["exam-card"]} ${active ? styles["active"] : ''}`}
      onClick={() => onClick(exam)}
    >
      <div className={styles["exam-title"]}>
        <CalendarOutlined 
          className={styles["title-icon"]} 
        />
        <span>{exam.title}</span>
      </div>
      <div className={styles["exam-card-details"]}>
        <div className={styles["exam-subjects"]}>
          Subjects:{" "}
          {subjects?.length === 0 ? (
            "-"
          ) : (
            <div className={styles["exam-subjects-value"]}>
              {visibleSubjects}
              {extraSubjects?.length > 0 && (
                <Tooltip 
                  title={extraSubjects?.join(", ")}
                  color="var(--primary-color)"
                >
                  <span className={styles["subject-more-tooltip"]}>
                    +{extraSubjects?.length}
                  </span>
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <div className={styles["exam-date"]}>
          <CalendarOutlined /> {dayjs(exam?.date).format(DATE_FORMAT.D_MMMM_YYYY)}
        </div>
      </div>
    </div>
  );
};

export default ExamCard;
